<template>
  <RouterLink
    :to="{ name: 'get-started' }"
    v-slot="{ navigate }"
    class="inline-block mx-auto w-full md:max-w-[280px]">
    <OtivoButton
      size="large"
      class="w-full"
      :colour="props.colour"
      @click="handleClick(navigate)"
      data-test="homeBtnTrial">
      <slot>Free to start</slot>
    </OtivoButton>
  </RouterLink>
</template>

<script setup lang="ts">
import OtivoButton from '@/components/OtivoButton.vue'
import { trackButtonClick } from '@/services/AnalyticsService'

interface Props {
  colour?: 'blue' | 'red' | 'white' | 'sky' | 'dark-red' | 'black' | 'transparent'
}

const props = withDefaults(defineProps<Props>(), {
  colour: 'blue',
})

const handleClick = (navigate: () => void) => {
  trackButtonClick(
    'free-to-start-button',
    'Free to start',
    {
      destination: 'plans',
      source: 'homepage',
      button_type: 'cta',
    },
    'subscriptions',
  )

  navigate()
}
</script>

<style scoped></style>
